var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.725 11.666a52.68 52.68 0 01.333-.682 138.115 138.115 0 01.709-1.4c.121-.24.234-.46.338-.662.108-.202.195-.36.26-.474a.852.852 0 01-.343.11 3.56 3.56 0 01-.438.004 1.612 1.612 0 01-.604-.125 1.648 1.648 0 01-.755-.666 2.998 2.998 0 01-.203-.412 2.9 2.9 0 01-.11-.375 1.698 1.698 0 01-.03-.276c0-.02-.002-.059-.006-.114V6.41v-.208a1.979 1.979 0 01.047-.36 2.738 2.738 0 01.328-.802c.094-.16.215-.309.365-.447a2.17 2.17 0 01.557-.36c.222-.1.484-.165.786-.192.316-.028.594-.01.834.057.243.066.451.161.625.286.173.125.318.271.432.438.115.166.203.337.266.51.066.17.11.337.13.5.02.16.024.297.01.412-.02.17-.043.323-.067.458a4.068 4.068 0 01-.089.38 4.302 4.302 0 01-.11.36c-.04.118-.09.246-.145.385a3.535 3.535 0 01-.115.25c-.059.128-.135.286-.229.474l-.302.62c-.108.225-.219.453-.333.682l-.896 1.813H6.725zm.234-5.5c0 .136.007.285.021.448.014.164.054.318.12.464.07.142.177.266.323.37.146.1.35.158.615.172a.922.922 0 00.359-.047 1.094 1.094 0 00.5-.386 1.463 1.463 0 00.24-.474.727.727 0 00.026-.166 38.066 38.066 0 01-.01-.292 1.778 1.778 0 00-.126-.646.789.789 0 00-.193-.27.848.848 0 00-.322-.178 1.271 1.271 0 00-.485-.052.992.992 0 00-.531.162 1.295 1.295 0 00-.323.323 1.2 1.2 0 00-.167.343 1.034 1.034 0 00-.047.23z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource9;